module.exports = __webpack_public_path__ + "static/img/swiper8.ee027472.png";